if (!customElements.get('mdv-testimonial-slider')) {
  customElements.define(
    'mdv-testimonial-slider',
    class MDVTestimonailSlider extends HTMLElement {
      connectedCallback() {
        if (this._initObserver || this.imageSwiper) return;
        var rect = this.getBoundingClientRect();
        var nearViewport = rect.top < window.innerHeight + 200 && rect.bottom > -200;
        if (nearViewport || !('IntersectionObserver' in window)) {
          this.init();
          return;
        }
        this._initObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.init();
              this._initObserver.disconnect();
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0 });
        this._initObserver.observe(this);
      }
      disconnectedCallback() {
        if (this._initObserver) this._initObserver.disconnect();
      }
      init() {
        const that = this;
        this.imageSwiper = new Swiper(this.querySelector('.swiper'), {
            centeredSlides : true,
            loop           : true,         // ← KEY FIX: loop so slide 0 can center with clones on both sides
            slidesPerView  : 1,
            spaceBetween   : 15,
            initialSlide   : 0,
            speed          : 500,
             navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
                750: {
                    slidesPerView : 1.6,
                    spaceBetween  : 30,
                }
            },
        });
        
      }
        
    }
  );
}